import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import {
  SUCCESS_TIME_MESSAGE,
  ERROR_TIME_MESSAGE,
  NOTIFICATION_H_POS,
  NOTIFICATION_V_POS,
} from '../handover-constants';

@Injectable({
  providedIn: 'root',
})
export class NotificationService {
  constructor(private _snackBar: MatSnackBar) {}

  notify(message: string, successMessage: boolean): void {
    const timeDuration = successMessage
      ? SUCCESS_TIME_MESSAGE
      : ERROR_TIME_MESSAGE;
    const hPosition = NOTIFICATION_H_POS;
    const vPosition = NOTIFICATION_V_POS;
    const action = 'X';
    const messageClass = successMessage
      ? 'success-notify-snackbar'
      : 'error-notify-snackbar';

    this._snackBar.open(message, action, {
      duration: timeDuration,
      horizontalPosition: hPosition,
      verticalPosition: vPosition,
      panelClass: messageClass,
    });
  }

  notifyManualClose(message: string, successMessage: boolean): void {
    const hPosition = NOTIFICATION_H_POS;
    const vPosition = NOTIFICATION_V_POS;
    const action = 'X';
    const messageClass = successMessage
      ? 'success-notify-snackbar'
      : 'error-notify-snackbar';

    this._snackBar.open(message, action, {
      horizontalPosition: hPosition,
      verticalPosition: vPosition,
      panelClass: messageClass,
    });
  }
}
